<div class="container pd-bottom-90">
  <h1 class="title">{{ 'FAVORITES.TITLE' | translate }}</h1>
  <div class="content-field">
    <div class="form-field">
      <mat-icon class="icon-search" svgIcon="search"></mat-icon>
      <input
        type="text"
        [(ngModel)]="search"
        [placeholder]="'FAVORITES.SEARCH' | translate"
        (input)="filterProducts()"
      />
      <mat-icon *ngIf="search" class="icon-clear" (click)="cancelSearch()" svgIcon="close"></mat-icon>
    </div>
    <button *ngIf="search" class="btn-cancel" (click)="cancelSearch()">{{ 'BUTTONS.CANCEL' | translate }}</button>
  </div>
  <div class="products">
    @for (item of filteredProducts; track item) {
      <app-product-card
        [id]="item.id"
        [title]="item.name"
        [description]="item.description"
        [price]="item.price/100"
        [imageUrl]="item.imageUrl"
        [isFavorite]="item.isFavorite"
        [productData]="item"
      ></app-product-card>
    } @empty {
      <app-empty-state
        [title]="'SEARCH_FIELD.NO_RESULTS_FOUND' | translate"
        [description]="'SEARCH_FIELD.NO_RESULTS_FOUND_FAVORITE' | translate"
        [showSuggestion]="true"
      ></app-empty-state>
    }
  </div>
</div>
<app-bottom-nav></app-bottom-nav>